<template>
  <div>
    <div class="btn Pointer btn-outline-info" @click="openModal" data-toggle="modal" data-target="#Modal-Setting">
      <i class="fas fa-list ml-2"></i>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="Modal-Setting" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="Modal-SettingLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h5 class="modal-title text-dark" id="Modal-SettingLabel">{{ !$cookies.get("IsAnbohSaz") == false ? "انتخاب نوع وام" : "انتخاب نوع واحد" }}</h5>
            <!-- <button type="button" class="close text-light" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> -->
          </div>
          <div class="modal-body text-right">
            <!-- v-for="(item, key) in Vamha" :key="key" -->
            <div v-for="(item, key) in Vamha" :key="key" class="row px-3">
              <div class="col-3"></div>
              <div class="col-12 col-md-6 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-6 text-right">
                      <span class="text-secondary">{{ !$cookies.get("IsAnbohSaz") == false ? "نام تسهیلات : " : "نام واحد : " }} </span>
                      <span class="text-dark font-weight-bold">{{ item.desNoe }}</span>
                    </div>

                    <div class="col-6 text-left">
                      <button v-if="SelectedVam.id != item.id" @click="seLectVam(item)" class="btn NetPa-btn btn-primary">انتخاب</button>
                      <span v-else class="text-success font-weight-bold"> انتخاب شده <i class="fas fa-check"></i></span>
                    </div>
                    <div class="col-12 mt-1 text-right">
                      <span class="text-secondary"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="$router.go(-1)" class="btn btn-secondary" data-dismiss="modal">انصراف</button>
          </div>
        </div>
      </div>
    </div>

    <Panel
      Title="تنظیمات درخواست وام"
      Des="در این منو میتوانید تنظیمات مربوط به شرایط درخواست وام و دیگر تنظیمات آنرا در سامانه خود را انجام دهید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></Panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link text-dark active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true"> تنظیمات کلی </a>
            <a class="nav-item nav-link text-dark" id="nav-zamen-tab" data-toggle="tab" href="#nav-zamen" role="tab" aria-controls="nav-zamen" aria-selected="false">تنظیمات شرایط ضامنین</a>
            <!-- <a class="nav-item nav-link text-dark" id="nav-upload-tab" data-toggle="tab" href="#nav-upload" role="tab" aria-controls="nav-upload" aria-selected="false">تنظیمات شرایط مدارک</a> -->
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات کلی</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div v-if="IsSetting" class="alert alert-success w-100 text-dark font-weight-bold text-right">تسهیلات {{ SelectedVam.desNoe }} برای تنظیمات انتخاب شد</div>
                  <div v-else class="alert alert-danger w-100 text-danger font-weight-bold text-right">برای تسهیلات {{ SelectedVam.desNoe }} هیچ تنظیماتی انجام نشده</div>
                </div>
                <div class="row">
                  <div class="col-12 border-bottom py-2">
                    <div class="row">
                      <div class="col-md-4 col-12 text-right mt-2">
                        <!-- <small> فعال سازی </small> -->
                        <span class="form-control p-1 mt-1">
                          <div class="custom-control custom-switch text-center">
                            <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" checked id="IsActive" v-model="DataModelSetting.IsActive" />
                            <label class="custom-control-label p-1" for="IsActive">مجوز برای درخواست وام </label>
                          </div>
                        </span>
                      </div>
                      <div class="col-md-4 col-12 text-right mt-2" v-if="IsFormulEqual == true || IsFormulEqualMin == true || IsFormolEqualhoghogh == true || IsFormulEqualMax == true">
                        <span class="form-control p-1 mt-1">
                          <div class="custom-control custom-switch text-center">
                            <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" checked id="IsFixInputMablaghVam" v-model="DataModelSetting.IsFixInputMablaghVam" />
                            <label class="custom-control-label p-1" for="IsFixInputMablaghVam">عدم امکان تغییر مبلغ وام </label>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 text-right mt-2" v-if="$session.get('CustCode') == 932">
                    <small id="LblIsHaghighi">محاسبه مبلغ تسهیلات چندبرابری </small>
                    <div class="form-control text-center mt-1">
                      <div class="custom-control custom-switch">
                        <h6 id="LbltblComboGrpId50" class="ml-2 d-inline">بر اساس فرمول</h6>
                        <input
                          type="checkbox"
                          class="custom-control-input required InputText"
                          @change="ChangeChkTblNoeEqual($event, IsFormulEqual)"
                          id="Done"
                          v-model="IsFormulEqual"
                          :disabled="!EditMode"
                        />
                        <label class="custom-control-label" for="Done"> </label>
                        <h6 class="mr-5 d-inline">بدون فرمول</h6>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2" v-if="$session.get('CustCode') == 932 && IsFormulEqual == false">
                    <small>{{ !$cookies.get("IsAnbohSaz") == false ? " حداقل میزان درخواست " : "حداقل واحد درخواستی" }}</small>
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      :disabled="!EditMode"
                      @keyup="$PutCommatoInput()"
                      dir="ltr"
                      maxlength="20"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.MinMablagh"
                    />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2" v-if="$session.get('CustCode') == 932 && IsFormulEqual == false">
                    <small>{{ !$cookies.get("IsAnbohSaz") == false ? " حداکثر میزان درخواست " : "حداکثر واحد درخواستی" }}</small>
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      :disabled="!EditMode"
                      @keyup="$PutCommatoInput()"
                      dir="ltr"
                      maxlength="20"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.MaxMablagh"
                    />
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2" v-if="$session.get('CustCode') == 932 && IsFormulEqual == true">
                    <small> حداکثر میزان درخواست </small>
                    <div class="row mt-2">
                      <div class="col-3 px-2">
                        <input class="form-control text-center w-100 required" @keypress="$ValidNumber($event, 3, true)" v-model="DataModelSetting.Equal" :disabled="!EditMode" />
                      </div>
                      <div class="col-2 mt-2 text-right px-1">برابر</div>
                      <div class="col-7 text-center pr-0 text-right">
                        <select class="form-control Pointer required" @change="ChangeTblNoeEquals" v-model="DataModelSetting.tblNoeIdEqual" :disabled="!EditMode">
                          <option :value="-1">-- انتخاب سپرده | حساب --</option>
                          <option v-for="item in this.Hesabha" :key="item.id" :value="item.id">
                            <span>{{ item.desNoe }} </span>
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Customer  (843) Bime Iran And All-->
                  <div class="col-12 border-bottom" v-if="$session.get('CustCode') != 932">
                    <div class="row py-2">
                      <div class="col-md-2 col-12 text-left">
                        <h6 class="mt-4">حداقل مبلغ درخواست وام</h6>
                      </div>
                      <div class="col-md-3 col-12 text-center">
                        <div class="form-control text-center mt-3">
                          <div class="custom-control custom-switch">
                            <h6 id="LbltblComboGrpId50" class="ml-2 d-inline">محاسبه فرمول</h6>
                            <input
                              type="checkbox"
                              class="custom-control-input required InputText"
                              @change="ChangeChkMinMaxMablagh($event, true)"
                              id="Min"
                              v-model="IsFormulEqualMin"
                              :disabled="!EditMode"
                            />
                            <label class="custom-control-label" for="Min"> </label>
                            <h6 class="mr-5 d-inline">بدون فرمول</h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12 text-right" v-if="IsFormulEqualMin == false">
                        <input
                          class="form-control mt-3 text-center 3ragham text-danger"
                          :disabled="!EditMode"
                          @keyup="$PutCommatoInput()"
                          dir="ltr"
                          maxlength="20"
                          style="font-size: 16px"
                          type="text"
                          v-model="DataModelSetting.MinMablagh"
                        />
                      </div>
                      <div class="col-md-1 col-12 text-right mt-3" v-if="IsFormulEqualMin == true">
                        <input class="form-control text-center w-100 required" type="number" v-model="DataModelSetting.EqualMin" :disabled="!EditMode" />
                      </div>
                      <div class="col-md-1 col-12 text-right" v-if="IsFormulEqualMin == true">
                        <h6 class="mt-4">برابر مجموع</h6>
                      </div>
                      <div class="col-md-4 col-12 text-right" v-if="IsFormulEqualMin == true" style="z-index: 1001">
                        <small>انتخاب حساب ها جهت محاسبه مجموع موجودی</small>
                        <treeselect :disabled="!EditMode" class="mt-1" v-model="value" :multiple="true" :options="options" name="Min" />
                      </div>
                    </div>
                    <div class="row py-2" v-if="$session.get('CustCode') == '259'">
                      <div class="col-md-2 col-12 text-left">
                        <h6 class="mt-4">حداکثر مبلغ درخواست وام</h6>
                      </div>
                      <div class="col-md-3 col-12 text-center">
                        <div class="form-control text-center mt-3">
                          <div class="custom-control custom-switch">
                            <h6 id="LbltblComboGrpId50" class="ml-2 d-inline">محاسبه فرمول</h6>
                            <input
                              type="checkbox"
                              class="custom-control-input required InputText"
                              @change="ChangeChkMinMaxMablagh($event, false)"
                              id="Max"
                              v-model="IsFormolEqualhoghogh"
                              :disabled="!EditMode"
                            />
                            <label class="custom-control-label" for="Max"> </label>
                            <h6 class="mr-5 d-inline">بدون فرمول</h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12 text-right" v-if="IsFormolEqualhoghogh == false">
                        <input
                          class="form-control mt-3 text-center 3ragham text-danger"
                          :disabled="!EditMode"
                          @keyup="$PutCommatoInput()"
                          dir="ltr"
                          maxlength="20"
                          style="font-size: 16px"
                          type="text"
                          v-model="DataModelSetting.MaxMablagh"
                        />
                      </div>
                      <div class="col-md-1 col-12 text-right mt-3" v-if="IsFormolEqualhoghogh == true">
                        <input class="form-control text-center w-100 required" type="number" v-model="DataModelSetting.EqualHoghogh" :disabled="!EditMode" />
                      </div>
                      <div class="col-md-1 col-12 text-right" v-if="IsFormolEqualhoghogh == true">
                        <h6 class="mt-4">برابر</h6>
                      </div>
                      <div class="col-md-3 col-12 text-right" v-if="IsFormolEqualhoghogh == true">
                        <h5 class="mt-3">مبلغ حقوق پایه</h5>
                      </div>
                    </div>
                    <div class="row py-2" v-else>
                      <div class="col-md-2 col-12 text-left">
                        <h6 class="mt-4">حداکثر مبلغ درخواست وام</h6>
                      </div>
                      <div class="col-md-3 col-12 text-center">
                        <div class="form-control text-center mt-3">
                          <div class="custom-control custom-switch">
                            <h6 id="LbltblComboGrpId50" class="ml-2 d-inline">محاسبه فرمول</h6>
                            <input
                              type="checkbox"
                              class="custom-control-input required InputText"
                              @change="ChangeChkMinMaxMablagh($event, false)"
                              id="Max"
                              v-model="IsFormulEqualMax"
                              :disabled="!EditMode"
                            />
                            <label class="custom-control-label" for="Max"> </label>
                            <h6 class="mr-5 d-inline">بدون فرمول</h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12 text-right" v-if="IsFormulEqualMax == false">
                        <input
                          class="form-control mt-3 text-center 3ragham text-danger"
                          :disabled="!EditMode"
                          @keyup="$PutCommatoInput()"
                          dir="ltr"
                          maxlength="20"
                          style="font-size: 16px"
                          type="text"
                          v-model="DataModelSetting.MaxMablagh"
                        />
                      </div>
                      <div class="col-md-1 col-12 text-right mt-3" v-if="IsFormulEqualMax == true">
                        <input class="form-control text-center w-100 required" type="number" v-model="DataModelSetting.EqualMax" :disabled="!EditMode" />
                      </div>
                      <div class="col-md-1 col-12 text-right" v-if="IsFormulEqualMax == true">
                        <h6 class="mt-4">برابر مجموع</h6>
                      </div>
                      <div class="col-md-4 col-12 text-right" v-if="IsFormulEqualMax == true">
                        <small>انتخاب حساب ها جهت محاسبه مجموع موجودی</small>
                        <treeselect :disabled="!EditMode" class="mt-1" v-model="valueMax" :multiple="true" :options="optionsMax" name="Max" />
                      </div>
                    </div>
                  </div>
                  <!-- End Customer (843) -->

                  <div class="col-md-3 col-12 text-right mt-2">
                    <small> محاسبات </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="Isformula" :disabled="!EditMode" v-model="DataModelSetting.Isformula" />
                        <label style="font-size: 12px" class="custom-control-label p-1" for="Isformula">محاسبات مبلغ و تعداد بر اساس فرمول </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2">
                    <small> نداشتن بدهی </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="ischeckupMandeAllTaahodat" :disabled="!EditMode" v-model="DataModelSetting.ischeckupMandeAllTaahodat" />
                        <label style="font-size: 12px" class="custom-control-label p-1" for="ischeckupMandeAllTaahodat"> نداشتن بدهی از هر نوع وام </label>
                      </div>
                    </span>
                  </div>

                  <div class="col-md-3 col-12 text-right mt-2">
                    <small> بارگذاری مدارک </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="IsUpload" v-model="DataModelSetting.IsUpload" />
                        <label style="font-size: 12px" class="custom-control-label p-1" for="IsUpload"> الزام به بارگذاری مدارک </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2">
                    <small> بررسی سفته الکترونیکی </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="IsSafteElectronic" v-model="DataModelSetting.IsSafteElectronic" />
                        <label style="font-size: 12px" class="custom-control-label p-1" for="IsSafteElectronic"> الزام به بررسی سفته الکترونیکی </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداقل تعداد اقساط درخواستی </small>
                    <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.MinTedad" />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداکثر تعداد اقساط درخواستی </small>
                    <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.MaxTedad" />
                  </div>
                  <div class="col-md-4 col-12 text-right mt-2">
                    <small id="LblIsMaxBedehi">محاسبه حداکثر میزان بدهی از این نوع وام </small>
                    <div class="form-control text-center mt-1">
                      <div class="custom-control custom-switch">
                        <small id="LbltblComboGrpId50" class="ml-2 font-weight-normal text-secondary">بر اساس تعداد قسط</small>
                        <input type="checkbox" class="custom-control-input required InputText" id="MaxBedehi" v-model="IsFormolMaxBedehi" :disabled="!EditMode" />
                        <label class="custom-control-label" for="MaxBedehi"> </label>
                        <small class="mr-5 font-weight-normal text-secondary">بر اساس مبلغ</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2" v-if="!IsFormolMaxBedehi && !$cookies.get('IsAnbohSaz') == false">
                    <small> حداکثر مبلغ بدهی از این نوع وام </small>
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      :disabled="!EditMode"
                      @keyup="$PutCommatoInput()"
                      dir="ltr"
                      maxlength="20"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.MaxBedeh"
                    />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2" v-if="IsFormolMaxBedehi">
                    <small> حداکثر تعداد قسط باقی مانده </small>
                    <input class="form-control mt-2 text-center" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.MaxTedadGhestBedeh" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداقل ماه سابقه عضویت </small>
                    <input
                      class="form-control mt-2 text-center text-danger"
                      :disabled="!EditMode"
                      dir="ltr"
                      maxlength="3"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.SabeghehOzviyat"
                    />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> بررسی موجودی حساب </small>
                    <select class="form-control Pointer mt-2" v-model="DataModelSetting.TblNoeIdPas" :disabled="!EditMode" @change="ChangeNoe()">
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option v-for="item in this.Hesabha" :key="item.id" :value="item">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2" v-if="DataModelSetting.TblNoeIdPas != -1 && DataModelSetting.TblNoeIdPas != null">
                    <small>حداقل موجودی حساب </small> {{ $cookies.get("VahedPool") }}
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      :disabled="!EditMode"
                      style="font-size: 16px"
                      @keyup="$PutCommatoInput()"
                      type="text"
                      v-model="DataModelSetting.MinMojodiPas"
                    />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداکثر بودجه ماهیانه</small>
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      :disabled="!EditMode"
                      @keyup="$PutCommatoInput()"
                      dir="ltr"
                      maxlength="20"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.MaxBodjeMahane"
                    />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> محدوده درخواست از روز </small>
                    <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.AzDay" />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> محدوده درخواست تا روز </small>
                    <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.TaDay" />
                  </div>
                </div>
                <!-- v-if="$session.get('CustCode') == '8002' || $session.get('CustCode') == '932' || $session.get('CustCode') == '814'" -->
                <div class="row mt-2">
                  <div class="col-md-2 col-12 mt-2">
                    <small>حداقل ماه - از افتتاح حساب</small>
                    <input type="number" class="form-control text-center" :disabled="!EditMode" v-model="DataModelSetting.MinMahAzEftetahHesab" @keypress="$ValidNumber($event, 2, false)" />
                  </div>
                  <div class="col-md-5 col-12 mt-2">
                    <small>انتخاب نوع حساب</small>
                    <select class="form-control Pointer" v-model="DataModelSetting.tblnoeEftetahHesab" :disabled="!EditMode" @change="ChangeNoeEftetahHesab()">
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option v-for="item in this.Hesabha" :key="item.id" :value="item.id">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-3 col-12 mt-2 text-right">
                    <small> حداقل ماه از تسویه وام قبلی گذشته باشد </small>
                    <input
                      class="form-control mt-2 text-center text-danger"
                      :disabled="!EditMode"
                      dir="ltr"
                      maxlength="3"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.MinMahAzTasvieHaminNoe"
                    />
                  </div>
                  <div class="col-md-3 col-12 mt-2 text-right" v-if="$session.get('CustCode') == 259 || $session.get('CustCode') == 8002">
                    <small> حداقل درصد از تسویه وام قبلی گذشته باشد </small>
                    <input
                      class="form-control mt-2 text-center text-danger"
                      :disabled="!EditMode"
                      dir="ltr"
                      maxlength="3"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataModelSetting.MinDarsadAzTasvieHaminNoe"
                      v-mask="'##%'"
                    />
                  </div>
                  <div class="col-md-3 col-12 mt-2 text-right" style="z-index: 1002" v-if="$session.get('CustCode') == 259 || $session.get('CustCode') == 8002">
                    <small>انتخاب تسهیلات ها جهت محاسبه درصد موجودی</small>
                    <treeselect :disabled="!EditMode" class="mt-2" v-model="valueDarsad" :multiple="true" :options="optionsDarsad" name="Darsad" />
                  </div>
                  <div class="col-md-3 col-12 mt-2 text-right" style="z-index: 1003">
                    <small>انتخاب تسهیلات هایی که نباید درخواست فعال داشته باشند</small>
                    <treeselect :disabled="!EditMode" class="mt-2" v-model="valueTashilatNotMojaz" :multiple="true" :options="optionsDarsad" name="TaahodatNotMojaz" />
                  </div>
                  <!-- <div class="col-md-4 col-12 text-right mt-2" v-if="DataModelSetting.MinMahAzTasvieHaminNoe>0">
                    <small id="LblIsMaxBedehiTasvie">محاسبه زودکرد دیرکرد آخرین قسط  </small>
                    <div class="form-control text-center mt-2">
                      <div class="custom-control custom-switch">
                        <small id="LbltblComboGrpId50" class="ml-2 font-weight-normal text-secondary">محاسبه شود</small>
                        <input type="checkbox" class="custom-control-input required InputText" id="IsMaxBedehiTasvie" v-model="DataModelSetting.IsMohasebeZodkardDirKardAxarinGhest" :disabled="!EditMode" />
                        <label class="custom-control-label" for="IsMaxBedehiTasvie"> </label>
                        <small class="mr-5 font-weight-normal text-secondary">محاسبه نــشود</small>
                      </div>
                    </div>
                  </div> -->
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-12 text-right mt-2">
                    <textarea class="form-control text-right mt-3" type="text" :disabled="!EditMode" placeholder="شرایط بارگذاری مدارک" rows="4" v-model="DataModelSetting.DesUpload"></textarea>
                  </div>
                  <div class="col-md-6 col-12 text-right mt-2">
                    <textarea
                      class="form-control text-right mt-3"
                      type="text"
                      :disabled="!EditMode"
                      :placeholder="!$cookies.get('IsAnbohSaz') == false ? 'شرایط دریافت تسهیلات' : 'شرایط دریافت واحد'"
                      rows="4"
                      v-model="DataModelSetting.Des"
                    ></textarea>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>

          <div class="tab-pane fade" id="nav-zamen" role="tabpanel" aria-labelledby="nav-zamen-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات شرایط ضامنین</h6>
              </template>
              <template slot="content">
                <button :disabled="!EditMode" v-if="addZamen == false" class="btn btn-success my-2" @click="addZamen = true">اضافه کردن</button>

                <vue-bootstrap4-table :rows="rows" :action="true" :columns="columns" :config="config" :classes="classes" v-if="addZamen == false">
                  <template slot="isOzv" slot-scope="props">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" :checked="props.cell_value" id="checkTest" disabled />
                      <label class="custom-control-label" for="checkTest"></label>
                    </div>
                  </template>
                  <template slot="isUpload" slot-scope="props">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" :checked="props.cell_value" id="checkTest" disabled />
                      <label class="custom-control-label" for="checkTest"></label>
                    </div>
                  </template>
                  <template slot="mabAz" slot-scope="props">
                    <p class="text-center">
                      {{ $Comma3ragham(props.row.mabAz) }}
                    </p>
                  </template>
                  <template slot="mabTa" slot-scope="props">
                    <p class="text-center">
                      {{ $Comma3ragham(props.row.mabTa) }}
                    </p>
                  </template>

                  <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                  </template>
                  <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                  </template>
                  <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                  </template>
                  <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                  </template>
                  <template slot="Action" slot-scope="props">
                    <a href="javascript:;" class="mr-2 badge" :disabled="!EditMode" @click="OnDelete(props.row)">
                      <span class="fa fa-trash-alt text-secondary hover-danger" style="font-size: 15px"></span>
                    </a>
                  </template>
                </vue-bootstrap4-table>

                <div v-else id="addAccountBank">
                  <div class="row mt-2">
                    <div class="col-md-3 col-12 text-right mt-2">
                      <small>از مبلغ تسهیلات </small> {{ $cookies.get("VahedPool") }}
                      <input
                        class="form-control mt-2 text-center 3ragham text-danger"
                        :disabled="!EditMode"
                        style="font-size: 16px"
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz"
                      />
                    </div>
                    <div class="col-md-3 col-12 text-right mt-2">
                      <small>تا مبلغ تسهیلات </small> {{ $cookies.get("VahedPool") }}
                      <input
                        class="form-control mt-2 text-center 3ragham text-danger"
                        :disabled="!EditMode"
                        style="font-size: 16px"
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa"
                      />
                    </div>
                    <div class="col-md-2 col-12 text-right mt-2">
                      <small> تعداد ضامنین </small>
                      <input
                        class="form-control mt-2 text-center text-danger"
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="1"
                        style="font-size: 16px"
                        type="text"
                        v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad"
                      />
                    </div>
                    <div class="col-md-4 col-12 text-right mt-2">
                      <small> ضامن عضو باشد</small>
                      <span class="form-control p-1 mt-1">
                        <div class="custom-control custom-switch text-center">
                          <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="IsOzv" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv" />
                          <label style="font-size: 12px" class="custom-control-label p-1" for="IsOzv"> الزام به بررسی عضویت ضامن </label>
                        </div>
                      </span>
                    </div>
                    <div class="col-md-2 col-12 text-right mt-2">
                      <small> سقف تعداد ضمانت ضامنین </small>
                      <input
                        class="form-control mt-2 text-center text-danger"
                        dir="ltr"
                        maxlength="1"
                        style="font-size: 16px"
                        type="number"
                        v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.MaxCountForZemanat"
                      />
                    </div>
                    <div class="col-md-4 col-12 text-right mt-2">
                      <small> بارگذاری مدارک ضامن </small>
                      <span class="form-control p-1 mt-1">
                        <div class="custom-control custom-switch text-center">
                          <input
                            type="checkbox"
                            class="custom-control-input InputText"
                            :disabled="!EditMode"
                            id="WwwtblNoeZamenPolicyOnlineIsUpload"
                            v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload"
                          />
                          <label style="font-size: 12px" class="custom-control-label p-1" for="WwwtblNoeZamenPolicyOnlineIsUpload"> الزام به بارگذاری مدارک ضامن </label>
                        </div>
                      </span>
                    </div>
                  </div>
                  <!-- <div class="row mt-2">
                  <div class="col-md-6 col-12 text-right mt-2" >
                    <textarea class="form-control text-right mt-3" type="text" :disabled="!EditMode" placeholder="شرایط بارگذاری مدارک ضامن" rows="4" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload"></textarea> 
                 </div>
                 </div> -->
                </div>
                <div v-if="Isgrid == false && addZamen == true" class="row mt-5">
                  <button :disabled="!EditMode" class="btn btn-success mx-3" @click="submitAddZamen()">ثبت</button>
                  <button :disabled="!EditMode" class="btn btn-danger" @click="addZamen = false">لغو</button>
                </div>
                <div v-if="Isgrid == true && addZamen == true" class="row mt-5">
                  <button :disabled="!EditMode" class="btn btn-success mx-3" @click="addgridZamen()">اضافه به لیست</button>
                  <button :disabled="!EditMode" class="btn btn-danger" @click="addZamen = false">لغو</button>
                </div>
              </template>
            </net-pa-card>
          </div>

          <!-- <div class="tab-pane fade " id="nav-upload" role="tabpanel" aria-labelledby="nav-upload-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات شرایط مدارک </h6>
              </template>
              <template slot="content">
              </template> 
            </net-pa-card>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9"></div>
      <div class="col-md-3 col-12">
        {{ rows.lenght }}
        <button v-if="EditMode" class="btn btn-success w-100" @click="SaveData">ثبت اطلاعات</button>
        <button v-else class="btn btn-warning w-100" @click="EditMode = !EditMode">اصلاح</button>
      </div>
    </div>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Panel, NetPaCard, VueBootstrap4Table, Treeselect },
  data() {
    return {
      options: [],
      optionsDarsad: [],
      optionsMax: [],
      value: null,
      valueMax: null,
      valueDarsad: null,
      valueTashilatNotMojaz: null,
      rows: [],
      columns: [
        { label: "id", name: "id", visibility: false },
        { label: "از مبلغ تسهیلات", name: "mabAz" },
        { label: "تا مبلغ تسهیلات", name: "mabTa" },
        { label: "تعداد ضامنین ", name: "tedad" },
        { label: "سقف تعداد ضمانت ضامنین ", name: "maxCountForZemanat" },
        { label: "عضویت ضامن", name: "isOzv" },
        { label: "الزام بارگذاری مدارک", name: "isUpload", visibility: true },
        { label: "شرایط بارگذاری مدارک", name: "desUpload", visibility: false },
        {
          label: "عملیات",
          name: "Action",
          visibility: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "  جستجو   ",
          visibility: false,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      addZamen: false,
      EditMode: false,
      Isgrid: false,
      DataModelSetting: {
        IsActive: true,
        MinMablagh: 0,
        MaxMablagh: 0,
        MinTedad: 1,
        MaxTedad: 36,
        MaxBedeh: 0,
        MaxTedadGhestBedeh: 0,
        MaxBodjeMahane: 0,
        AzDay: 1,
        TaDay: 31,
        IsUpload: false,
        TblNoeIdPas: -1,
        SabeghehOzviyat: 0,
        MinMojodiPas: 0,
        DesUpload: "",
        Des: "",
        IsSafteElectronic: false,
        Isformula: false,
        WwwtblNoeId: 0,
        BnpCashDbtblNoeId: 0,
        WwwtblNoeZamenPolicyOnline: {
          MabAz: 0,
          MabTa: 0,
          Tedad: 1,
          IsOzv: true,
          IsUpload: false,
          DesUpload: "",
          MaxCountForZemanat: 0,
        },
        tblNoeIdEqual: -1,
        Equal: null,
        ischeckupMandeAllTaahodat: false,
        MinMahAzTasvieHaminNoe: null,
        IsMohasebeZodkardDirKardAxarinGhest: false,
        MinDarsadAzTasvieHaminNoe: null,
        IsFixInputMablaghVam: false,
        tblNoeIdsNotMojaz:null
      },
      SelectedVam: {},
      IsSetting: false,
      DataAxiosGetNoeVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetTblNoe",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosSettingVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetSettingVam",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosZamenPolicy: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetZamenPolicyOnline",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosAddZamenPolicy: {
        ArryfildValue: {},
        Method: "Post",
        Action: "RequestVamNew/InsZamenPolicy",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SaveData: {
        ArryfildValue: {},
        Method: "Post",
        Action: "RequestVamNew/InsSettingVam",
        Token: this.$session.get("TokenNetPa"),
      },
      Vamha: [],
      Hesabha: [],
      DataAxiosDelete: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/DeleteZamenPolicy",
        Token: this.$session.get("TokenNetPa"),
      },
      IsFormulEqual: this.$session.get("CustCode") == 932 ? true : false,
      IsFormulEqualMin: false,
      IsFormulEqualMax: false,
      IsFormolMaxBedehi: false,
      IsFormolEqualhoghogh: false,
    };
  },
  methods: {
    SaveData() {
      if (!this.$ValidForm("nav-tabContent")) {
        return;
      }
      // console.log(this.SelectedVam);
      const WwwtblNoeZamenPolicyOnline = [];
      WwwtblNoeZamenPolicyOnline.push({
        MabAz: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz != "" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(/,/g, "").replace(/\./g, "") : 0,
        MabTa: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa != "" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(/,/g, "").replace(/\./g, "") : 0,
        Tedad: Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad),
        IsOzv: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv,
        IsUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload,
        DesUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload,
        MaxCountForZemanat: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MaxCountForZemanat,
      });

      // console.log(typeof(this.DataModelSetting.MinMojodiPas))
      this.DataAxios_SaveData.ArryfildValue.AzDay = Number(this.DataModelSetting.AzDay);
      this.DataAxios_SaveData.ArryfildValue.BnpCashDbtblNoeId = this.DataModelSetting.BnpCashDbtblNoeId;
      this.DataAxios_SaveData.ArryfildValue.Des = this.DataModelSetting.Des;
      this.DataAxios_SaveData.ArryfildValue.DesUpload = this.DataModelSetting.DesUpload;
      this.DataAxios_SaveData.ArryfildValue.IsActive = this.DataModelSetting.IsActive;
      this.DataAxios_SaveData.ArryfildValue.IsSafteElectronic = this.DataModelSetting.IsSafteElectronic;
      this.DataAxios_SaveData.ArryfildValue.IsUpload = this.DataModelSetting.IsUpload;
      this.DataAxios_SaveData.ArryfildValue.Isformula = this.DataModelSetting.Isformula;
      this.DataAxios_SaveData.ArryfildValue.TaDay = Number(this.DataModelSetting.TaDay);
      this.DataAxios_SaveData.ArryfildValue.MinTedad = Number(this.DataModelSetting.MinTedad);
      this.DataAxios_SaveData.ArryfildValue.MaxTedad = Number(this.DataModelSetting.MaxTedad);
      this.DataAxios_SaveData.ArryfildValue.SabeghehOzviyat = Number(this.DataModelSetting.SabeghehOzviyat);
      this.DataAxios_SaveData.ArryfildValue.MinMablagh = this.DataModelSetting.MinMablagh != "" ? this.DataModelSetting.MinMablagh.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxMablagh = this.DataModelSetting.MaxMablagh != "" ? this.DataModelSetting.MaxMablagh.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxBedeh =
        this.DataModelSetting.MaxBedeh != "" && this.IsFormolMaxBedehi == false ? this.DataModelSetting.MaxBedeh.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxTedadGhestBedehi = this.DataModelSetting.MaxTedadGhestBedeh != 0 && this.IsFormolMaxBedehi == true ? this.DataModelSetting.MaxTedadGhestBedeh : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxBodjeMahane = this.DataModelSetting.MaxBodjeMahane != "" ? this.DataModelSetting.MaxBodjeMahane.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxios_SaveData.ArryfildValue.MinMojodiPas = this.DataModelSetting.MinMojodiPas != "" ? this.DataModelSetting.MinMojodiPas.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxios_SaveData.ArryfildValue.TblNoeIdPas = this.DataModelSetting.TblNoeIdPas?.id;
      this.DataAxios_SaveData.ArryfildValue.WwwtblNoeId = this.DataModelSetting.WwwtblNoeId;
      this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqual = this.DataModelSetting.tblNoeIdEqual;
      this.DataAxios_SaveData.ArryfildValue.Equal = this.DataModelSetting.Equal;
      this.DataAxios_SaveData.ArryfildValue.EqualHoghogh = this.DataModelSetting.EqualHoghogh;
      this.DataAxios_SaveData.ArryfildValue.WwwtblNoeZamenPolicyOnline = this.rows.lenght == 0 ? WwwtblNoeZamenPolicyOnline : this.rows;
      this.DataAxios_SaveData.ArryfildValue.ischeckupMandeAllTaahodat = this.DataModelSetting.ischeckupMandeAllTaahodat;

      this.DataAxios_SaveData.ArryfildValue.tblnoeEftetahHesab = this.DataModelSetting.tblnoeEftetahHesab == -1 ? null : this.DataModelSetting.tblnoeEftetahHesab;
      this.DataAxios_SaveData.ArryfildValue.MinMahAzEftetahHesab =
        this.DataModelSetting.MinMahAzEftetahHesab == null || this.DataModelSetting.MinMahAzEftetahHesab == 0 ? null : this.DataModelSetting.MinMahAzEftetahHesab;
      this.DataAxios_SaveData.ArryfildValue.MinMahAzTasvieHaminNoe =
        this.DataModelSetting.MinMahAzTasvieHaminNoe == 0 || this.DataModelSetting.MinMahAzTasvieHaminNoe == null ? null : Number(this.DataModelSetting.MinMahAzTasvieHaminNoe);
      this.DataAxios_SaveData.ArryfildValue.MinDarsadAzTasvieHaminNoe =
        this.DataModelSetting.MinDarsadAzTasvieHaminNoe == "" || this.DataModelSetting.MinDarsadAzTasvieHaminNoe == null ? null : parseInt(this.DataModelSetting.MinDarsadAzTasvieHaminNoe);
      this.DataAxios_SaveData.ArryfildValue.IsMohasebeZodkardDirKardAxarinGhest =
        this.DataModelSetting.MinMahAzTasvieHaminNoe == 0 || this.DataModelSetting.MinMahAzTasvieHaminNoe == null ? null : this.DataModelSetting.IsMohasebeZodkardDirKardAxarinGhest;
      this.DataAxios_SaveData.ArryfildValue.IsFixInputMablaghVam = this.DataModelSetting.IsFixInputMablaghVam;
      let str = "";
      let strMax = "";
      let strDarsad = "";
      let strTashilatNotMojaz = "";

      if (this.IsFormulEqualMin == true) {
        this.value.forEach((val) => {
          str = str + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMin = str;
        this.DataAxios_SaveData.ArryfildValue.EqualMin = this.DataModelSetting.EqualMin;
        this.DataAxios_SaveData.ArryfildValue.MinMablagh = 0;
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMin = null;
        this.DataAxios_SaveData.ArryfildValue.EqualMin = null;
      }

      if (this.IsFormulEqualMax == true) {
        this.valueMax.forEach((val) => {
          strMax = strMax + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMax = strMax;
        this.DataAxios_SaveData.ArryfildValue.EqualMax = this.DataModelSetting.EqualMax;
        this.DataAxios_SaveData.ArryfildValue.MaxMablagh = 0;
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMax = null;
        this.DataAxios_SaveData.ArryfildValue.EqualMax = null;
      }

      if (this.valueDarsad != null && this.valueDarsad.length > 0 && parseInt(this.DataModelSetting.MinDarsadAzTasvieHaminNoe)) {
        this.valueDarsad.forEach((val) => {
          strDarsad = strDarsad + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdDarsadAzTasvieList = strDarsad.slice(0, -1);
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdDarsadAzTasvieList = null;
      }

      if (this.valueTashilatNotMojaz != null && this.valueTashilatNotMojaz.length > 0) {
        this.valueTashilatNotMojaz.forEach((val) => {
          strTashilatNotMojaz = strTashilatNotMojaz + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdsNotMojaz = strTashilatNotMojaz.slice(0, -1);
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdsNotMojaz = null;
      }

      this.$PostData(this.DataAxios_SaveData)
        .then((data) => {
          if (data.status == "OK") {
            this.$mySweetDefault("عملیات موفق", "ثبت تنظیمات با موفقیت انجام شد", "success", 2000);
            this.EditMode = !this.EditMode;
          } else {
            this.$mySweetDefault("عملیات ناموفق", "ثبت تنظیمات با مشکل مواجه شد", "warning", 2000);
            this.EditMode = !this.EditMode;
          }
        })
        .finally(() => {
          this.GetNoeVam();
        });
    },
    openModal() {
      $("#Modal-Setting").modal("show");
    },
    closeModal() {
      $("#Modal-Setting").modal("hide");
    },
    GetNoeVam() {
      // Object.assign(this.$data, this.$options.data.call(this));

      var formdata = new FormData();
      formdata.append("id", 1);
      this.DataAxiosGetNoeVam.ArryfildValue = formdata;
      this.$PostFormData(this.DataAxiosGetNoeVam)
        .then((data) => {
          // console.log(data);

          this.Vamha = data;
          this.pushToValuesForTree();
        })
        .finally(() => {
          this.openModal();
        });
    },
    GetNoePas() {
      var formdata = new FormData();
      formdata.append("id", 2);
      this.DataAxiosGetNoeVam.ArryfildValue = formdata;
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Hesabha = data;
        this.pushToValuesForTree();
      });
    },
    pushToValuesForTree() {
      let list = [];
      this.Hesabha.forEach((data) => {
        data["label"] = data.desNoe;
        list.push(data);
      });
      this.options = list;
      this.optionsMax = list;

      let list2 = [];
      this.Vamha.forEach((data) => {
        data["label"] = data.desNoe;
        list2.push(data);
      });
      this.optionsDarsad = list2;
    },
    seLectVam(data) {
      this.closeModal();
      this.SelectedVam = data;
      if (this.SelectedVam.id > 0) {
        this.DataModelSetting.BnpCashDbtblNoeId = this.SelectedVam.bnpCashDbtblNoeId;
        this.DataModelSetting.WwwtblNoeId = this.SelectedVam.id;
        this.GetSettingVam();
      }
    },
    GetSettingVam() {
      this.rows = [];
      var formdata = new FormData();
      formdata.append("id", this.SelectedVam.id);
      this.DataAxiosSettingVam.ArryfildValue = formdata;
      this.$PostFormData(this.DataAxiosSettingVam)
        .then((data) => {
          //this.Vamha = data
          if (data != null && data.isActive == true) {
            this.IsSetting = true;
            this.EditMode = false;
            this.Isgrid = false;

            this.DataModelSetting.Id = data.id;
            // this.DataModelSetting.WwwtblNoeId=data.wwwtblNoeId
            // this.DataModelSetting.BnpCashDbtblNoeId=data.bnpCashDbtblNoeId
            this.DataModelSetting.IsActive = data.isActive;
            this.DataModelSetting.Isformula = data.isformula;
            this.DataModelSetting.IsSafteElectronic = data.isSafteElectronic;
            this.DataModelSetting.MinMablagh = this.$Comma3ragham(data.minMablagh);
            this.DataModelSetting.MaxMablagh = this.$Comma3ragham(data.maxMablagh);
            this.DataModelSetting.MinTedad = data.minTedad;
            this.DataModelSetting.MaxTedad = data.maxTedad;
            this.DataModelSetting.MaxBedeh = this.$Comma3ragham(data.maxBedeh);
            this.DataModelSetting.AzDay = data.azDay;
            this.DataModelSetting.TaDay = data.taDay;
            this.DataModelSetting.MaxBodjeMahane = this.$Comma3ragham(data.maxBodjeMahane);
            this.DataModelSetting.MinMojodiPas = this.$Comma3ragham(data.minMojodiPas);
            this.DataModelSetting.SabeghehOzviyat = data.sabeghehOzviyat;
            this.DataModelSetting.Des = data.des;
            this.DataModelSetting.IsUpload = data.isUpload;
            this.DataModelSetting.DesUpload = data.desUpload;
            this.DataModelSetting.TblNoeIdPas = data.tblNoeIdPas;
            this.DataModelSetting.ischeckupMandeAllTaahodat = data.ischeckupMandeAllTaahodat;
            this.DataModelSetting.MaxTedadGhestBedeh = data.maxTedadGhestBedehi;

            this.DataModelSetting.MinMahAzTasvieHaminNoe = data.minMahAzTasvieHaminNoe;
            this.DataModelSetting.IsMohasebeZodkardDirKardAxarinGhest = data.isMohasebeZodkardDirKardAxarinGhest;
            this.DataModelSetting.IsFixInputMablaghVam = data.isFixInputMablaghVam;

            if (data.equal > 0 && data.equal != null && data.tblNoeIdEqual != null && data.tblNoeIdEqual != -1) {
              this.IsFormulEqual = true;
            } else {
              this.IsFormulEqual = false;
            }

            if (data.equalMin > 0 && data.equalMin != null && data.tblNoeIdEqualListMin != null && data.tblNoeIdEqualListMin != "") {
              this.IsFormulEqualMin = true;
              this.value = data.tblNoeIdEqualListMin.slice(0, -1).split(",");
            } else {
              this.IsFormulEqualMin = false;
            }

            if (data.equalMax > 0 && data.equalMax != null && data.tblNoeIdEqualListMax != null && data.tblNoeIdEqualListMax != "") {
              this.IsFormulEqualMax = true;
              this.valueMax = data.tblNoeIdEqualListMax.slice(0, -1).split(",");
            } else {
              this.IsFormulEqualMax = false;
            }

            if (data.minDarsadAzTasvieHaminNoe > 0 && data.minDarsadAzTasvieHaminNoe != null && data.tblNoeIdDarsadAzTasvieList != null && data.tblNoeIdDarsadAzTasvieList != "") {
              this.DataModelSetting.MinDarsadAzTasvieHaminNoe = data.minDarsadAzTasvieHaminNoe;
              this.valueDarsad = data.tblNoeIdDarsadAzTasvieList.split(",");
            } else {
              this.DataModelSetting.MinDarsadAzTasvieHaminNoe = null;
              this.valueDarsad = null;
            }

            if (data.maxTedadGhestBedehi > 0) {
              this.IsFormolMaxBedehi = true;
            } else {
              this.IsFormolMaxBedehi = false;
            }

            if (data.EqualHoghogh > 0 && data.EqualHoghogh != null) {
              this.IsFormolEqualhoghogh = true;
            } else {
              this.IsFormolEqualhoghogh = false;
            }

            if (data.tblNoeIdsNotMojaz!=null ) {
              this.DataModelSetting.tblNoeIdsNotMojaz=data.tblNoeIdsNotMojaz
              this.valueTashilatNotMojaz=data.tblNoeIdsNotMojaz.split(',')
            }

            this.DataModelSetting.tblNoeIdEqual = data.tblNoeIdEqual;
            this.DataModelSetting.Equal = data.equal;
            this.DataModelSetting.EqualMin = data.equalMin;
            this.DataModelSetting.EqualMax = data.equalMax;
            this.DataModelSetting.EqualHoghogh = data.equalHoghogh;
            this.DataModelSetting.tblnoeEftetahHesab = data.tblnoeEftetahHesab == null ? -1 : data.tblnoeEftetahHesab;
            this.DataModelSetting.MinMahAzEftetahHesab = data.minMahAzEftetahHesab == null ? 0 : data.minMahAzEftetahHesab;
            this.DataModelSetting.IsFixInputMablaghVam = data.isFixInputMablaghVam;
          } else {
            this.IsSetting = false;
            this.EditMode = true;
            this.rows = [];
            this.Isgrid = true;
            this.IsFormulEqual = false;
            this.IsFormulEqualMin = false;
            this.IsFormulEqualMax = false;
            // this.DataModelSetting = {
            //   IsActive: false,
            //   MinMablagh: 0,
            //   MaxMablagh: 0,
            //   MinTedad: 1,
            //   MaxTedad: 36,
            //   MaxBedeh: 0,
            //   MaxBodjeMahane: 0,
            //   AzDay: 1,
            //   TaDay: 31,
            //   IsUpload: false,
            //   TblNoeIdPas: -1,
            //   SabeghehOzviyat: 0,
            //   MinMojodiPas: 0,
            //   DesUpload: '',
            //   Des: '',
            //   IsSafteElectronic: false,
            //   Isformula: false,
            //   WwwtblNoeId: 0,
            //   BnpCashDbtblNoeId: 0,
            //   WwwtblNoeZamenPolicyOnline: {
            //     MabAz: 0,
            //     MabTa: 0,
            //     Tedad: 1,
            //     IsOzv: true,
            //     IsUpload: false,
            //     DesUpload: '',
            //     MaxCountForZemanat: 0,
            //   },
            //   tblNoeIdEqual: -1,
            //   Equal: null,
            //   ischeckupMandeAllTaahodat: false,
            // }
          }
        })
        .finally(() => {
          var formdata = new FormData();
          formdata.append("id", this.DataModelSetting.Id);
          this.DataAxiosZamenPolicy.ArryfildValue = formdata;
          this.$PostFormData(this.DataAxiosZamenPolicy)
            .then((res) => {
              // console.log('*/*/*',res);
              if (res != null) this.rows = res;
              else this.rows = [];
            })
            .finally(() => {
              this.GetNoePas();
            });
        });
    },
    ChangeNoe() {
      //this.DataModelSetting.TblNoeIdPas = this.DataModelSetting.TblNoeIdPas.id
    },
    ChangeNoeEftetahHesab() {
      // this.DataModelSetting.tblnoeEftetahHesab = this.DataModelSetting.tblnoeEftetahHesab.id
    },
    ChangeTblNoeEquals() {
      if (this.DataModelSetting.tblNoeIdEqual > 0 && this.DataModelSetting.Equal > 0) {
        this.DataModelSetting.MaxMablagh = 0;
      } else {
        this.DataModelSetting.tblNoeIdEqual = null;
        this.DataModelSetting.Equal = null;
      }
    },
    ChangeChkTblNoeEqual(e, IsFormulEqual) {
      if (IsFormulEqual == false) {
        this.DataModelSetting.tblNoeIdEqual = null;
        this.DataModelSetting.Equal = null;
        this.DataModelSetting.MaxMablagh = this.DataModelSetting.MinMablagh;
      }
    },
    ChangeChkMinMaxMablagh(e, IsMin) {
      if (IsMin == false) {
        if (this.IsFormulEqualMax == false) {
          this.DataModelSetting.tblNoeIdEqualListMax = null;
          // this.DataModelSetting.MaxMablagh = this.DataModelSetting.MinMablagh
        }
      }
      if (IsMin == true) {
        if (this.IsFormulEqualMin == false) {
          this.DataModelSetting.tblNoeIdEqualListMin = null;
        }
      }
    },
    submitAddZamen() {
      this.DataAxiosAddZamenPolicy.ArryfildValue.MabAz =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz != "" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxiosAddZamenPolicy.ArryfildValue.MabTa =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa != "" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(/,/g, "").replace(/\./g, "") : 0;
      this.DataAxiosAddZamenPolicy.ArryfildValue.Tedad = Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad);
      this.DataAxiosAddZamenPolicy.ArryfildValue.IsOzv = this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv;
      this.DataAxiosAddZamenPolicy.ArryfildValue.DesUpload = this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload;
      this.DataAxiosAddZamenPolicy.ArryfildValue.IsUpload = this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload;
      this.DataAxiosAddZamenPolicy.ArryfildValue.MaxCountForZemanat = this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MaxCountForZemanat;
      this.DataAxiosAddZamenPolicy.ArryfildValue.WwwtblSettingVamOnlineId = this.DataModelSetting.Id;

      this.$PostData(this.DataAxiosAddZamenPolicy)
        .then((data) => {
          if (data.status == "OK") {
            this.$mySweetDefault("عملیات موفق", "ثبت تنظیمات ضمانت با موفقیت انجام شد", "success", 2000);
            this.addZamen = false;
          }
        })
        .finally(() => {
          var formdata = new FormData();
          formdata.append("id", this.DataModelSetting.Id);
          this.DataAxiosZamenPolicy.ArryfildValue = formdata;
          this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
            if (res != null) this.rows = res;
            else this.rows = [];
          });
        });
    },
    OnDelete(row) {
      if (this.Isgrid) {
        for (let index = 0; index < this.rows.length; index++) {
          if (this.rows[index].id == row.id) {
            this.rows.splice(index, 1);
          }
        }
      } else {
        const formData = new FormData();
        formData.append("id", row.id);
        this.DataAxiosDelete.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosDelete)
          .then((data) => {
            if (data.status == "OK") {
              this.$mySweetDefault("حذف موفق", "تنظیمات ضامن با موفقیت حذف شد", "success", 2000);
            }
          })
          .finally(() => {
            var formdata = new FormData();
            formdata.append("id", this.DataModelSetting.Id);
            this.DataAxiosZamenPolicy.ArryfildValue = formdata;
            this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
              if (res != null) this.rows = res;
              else this.rows = [];
            });
          });
      }
    },
    addgridZamen() {
      this.rows.push({
        mabAz: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz != "" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(/,/g, "").replace(/\./g, "") : 0,
        mabTa: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa != "" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(/,/g, "").replace(/\./g, "") : 0,
        tedad: Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad),
        isOzv: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv,
        isUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload,
        desUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload,
        id: 1,
      });
      this.addZamen = false;
    },
  },
  mounted() {
    this.GetNoeVam();
  },
};
</script>
<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px;
  }
  .transparent {
    background-color: #fff0 !important;
    border: none !important;
  }
}
.modal-header {
  border-bottom: none;
}
.bg {
  background: rgb(142, 85, 1);
  background: linear-gradient(299deg, rgba(142, 85, 1, 1) 0%, rgba(230, 139, 3, 1) 100%);
}
.modal {
  margin-top: 2%;
}
.bg-warning {
  background: #fda82a !important;
}
.bg-Success {
  background: #67b221 !important;
}
.gradiant-back {
  background: rgb(60, 137, 168);
  background: linear-gradient(51deg, rgba(60, 137, 168, 1) 0%, rgba(23, 57, 71, 1) 100%);
}
.vue-treeselect--open-below:not(.vue-treeselect--append-to-body) .vue-treeselect__menu-container {
  z-index: 20 !important;
}
.vue-treeselect__control,
.vue-treeselect__value-container {
  z-index: 20000 !important;
}
</style>
